import { bankruptcyTerminationActionTypes as actionTypes } from '../ActionTypes/bankruptcyTerminationActionTypes'

const initialState = {}

export default function BankruptcyTerminationReducer(state = { ...initialState }, action) {
    let newState;

    switch (action.type) {
        case actionTypes.STORE_BANKRUPTCY_JOBS:
            newState = { jobs: action.data.items, jobsTotalPages: action.data.totalPages }
            break;
        case actionTypes.STORE_BANKRUPTCY_JOB_DETAIL:
            newState = {
                jobDetail: action.data,
                customerResults: action.data.customerResults.items,
                customerResultsTotalPages: action.data.customerResults.totalPages
            }
            break;
        case actionTypes.SET_MANUALLY_HANDLED:
            newState = {
                customerResults: state.customerResults.map(c =>
                    c.id === action.customerResultId
                        ? { ...c, manuallyHandled: action.value }
                        : c
                )
            }
            break;
        default:
            return state;
    }

    return Object.assign({}, state, newState)
}
